import { setGoNativeUserId } from '../gonative'

import { getAnalytics } from './global.analytics'
import { shouldUseSegment } from './segment.utils'

type UserId = { userId: string }
type HubloId = { hubloId: string }

export const segmentIdentify = (
  userProperties: UserId & HubloId & Record<string, unknown>,
): boolean => {
  const { userId, hubloId, ...rest } = userProperties
  if (shouldUseSegment(getAnalytics())) {
    //check if the user already been identified
    //check also if the user has the old version of the id
    if (
      !getAnalytics()?.user()?.id() ||
      getAnalytics()?.user()?.id()?.startsWith('v_')
    ) {
      getAnalytics().identify(userId, rest)
    }
    setGoNativeUserId(userId, hubloId)
    return true
  }
  return false
}
